import { Injectable } from '@angular/core';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { environment } from 'src/environments/environment';

@Injectable()
export class AppInsightsService {
  appInsights: ApplicationInsights;
  constructor() {
    this.appInsights = new ApplicationInsights({
      config: {
        instrumentationKey: environment.appInsights.instrumentationKey,
        enableAutoRouteTracking: true // option to log all route changes
      }
    });
    this.appInsights.loadAppInsights();
  }

  setUserId(userId: string): void{
    this.appInsights.setAuthenticatedUserContext(userId);
    this.appInsights.context.user.id = userId;
  }

  clearUserId(): void{
    this.appInsights.clearAuthenticatedUserContext();
  }

  logPageView(name?: string, url?: string): void{ // option to call manually
    this.appInsights.trackPageView({
      name: name,
      uri: url
    });
  }

  logEvent(name: string, properties?: { [key: string]: any }): void{
    this.appInsights.trackEvent({ name: name}, properties);
  }

  logMetric(name: string, average: number, properties?: { [key: string]: any }): void{
    this.appInsights.trackMetric({ name: name, average: average }, properties);
  }

  logException(exception: Error, severityLevel?: number): void{
    this.appInsights.trackException({ exception: exception, severityLevel: severityLevel });
  }

  logTrace(message: string, properties?: { [key: string]: any }): void{
    this.appInsights.trackTrace({ message: message}, properties);
  }

  logAjax(method: string, absoluteUrl: string, pathName: string, totalTime: number, success: boolean, resultCode: number, bodyRequest: any, bodyResponse?: any): void {
    if (absoluteUrl.substr(0, 8) === 'https://' || absoluteUrl.substr(0, 7) === 'http://') { // DOES NOT TRACK RELATIVE URLs
      this.appInsights.trackDependencyData(
        {
          id: absoluteUrl,
          duration: totalTime,
          name: absoluteUrl,
          responseCode: resultCode,
          success,
          type: method,
          data: bodyRequest,
          properties:
          {
            bodyRequest: JSON.stringify(bodyRequest),
            bodyResponse: JSON.stringify(bodyResponse),
          },
        });
    }
  }
}
